import { render } from "./InsuranceExceptionCases.vue?vue&type=template&id=0b373218"
import script from "./InsuranceExceptionCases.vue?vue&type=script&lang=js"
export * from "./InsuranceExceptionCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/InsuranceExceptionCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b373218"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b373218', __exports__)) {
    console.log('reload')
    api.reload('0b373218', __exports__)
  }
  
  module.hot.accept("./InsuranceExceptionCases.vue?vue&type=template&id=0b373218", () => {
    console.log('re-render')
    api.rerender('0b373218', render)
  })

}


export default __exports__